 // Whole Component Tejashwini
import Layout from "./layout";
import { Button, Box,Typography } from "@mui/material";
import { useNavigate } from 'react-router-dom';// Page linking using this 
const CreateProducts  = () => {
    const navigate = useNavigate();// Page linking using this 
    return(
        <>
        <Layout/>
        <h1 className="title" > Create Products</h1>
        <Box
                sx={{display: 'flex',justifyContent: 'center',alignItems: 'center',height: '70vh', gap: '8em', }}
            >
                <Button 
                    variant="contained"  onClick={() => {navigate('/erp-cat') }} // Page linking using this 
                                         
                    sx={{backgroundColor: '#0A64A2', marginBottom: '10em',right:'1em' ,color: '#fff',left:'2em', borderRadius:'0.4em' ,marginRight: '2em',padding: '39px 70px',fontSize: '14px',fontWeight: 'bold',fontFamily: ' sans-serif',
                    }}
                > 
                    Category
                </Button>
                      
                <Button
                    variant="contained" onClick={() => {navigate('/erp-brand') }} // Page linking using this 
                    sx={{backgroundColor: '#0A64A2',marginBottom: '10em',color: '#fff',padding: '39px 85px',fontSize: '14px',borderRadius:'0.4em' ,fontWeight: 'bold',fontFamily: ' sans-serif',
                    }}
                >
                    Brand
                </Button>

                <Button
                    variant="contained" onClick={() => {navigate('/erp-attri') }} // Page linking using this 
                    sx={{backgroundColor: '#0A64A2',marginBottom: '10em',color: '#fff',padding: '38px 71px',fontSize: '14px',fontWeight: 'bold',fontFamily: ' sans-serif',
                    }}
                >
                    Attribute
                </Button>

                <Button
                    variant="contained" onClick={() => {navigate('/erp-Products') }} // Page linking using this 
                    sx={{backgroundColor: '#0A64A2', right:'1em', marginBottom: '10em',color: '#fff',padding: '38px 71px',fontSize: '14px',fontWeight: 'bold',fontFamily: ' sans-serif',
                    }}
                > 
                    Products
                </Button>
            </Box>

        </>
    )
}

export default CreateProducts; 